module.exports = __webpack_public_path__ + "media/stylesheets/images/Tatsuro Machinaga-826dd42c617cd6e9751e2e94a692adf1.jpg";